<template lang="pug">
  div
    slot
</template>
<script>
import $ from 'jquery'
import MouseMixin from '@/components/shared/MouseMixin'

export default {
  props: {
    classes: {
      type: String,
      required: false,
      default: 'selected'
    },
    getValue: {
      type: Function,
      required: false,
      default: (child) => {
        return $(child).data('value')
      }
    },
    selected: {
      required: true
    }
  },
  mixins: [MouseMixin],
  mounted () {
    let that = this
    $(this.$el).on('mousedown.selectable', '> *', function () {
      that.consumeMouseEvents()
      that.$emit('update:selected', that.getValue(this))
    })
    this.select()
  },
  destroyed () {
    $(this.$el).off('mousedown.selectable')
  },
  methods: {
    select () {
      let that = this
      $('> *', this.$el).each(function () {
        if (that.getValue(this) === that.selected) {
          $(this).addClass(that.classes).siblings().removeClass(that.classes)
          return
        }
      })
    }
  },
  watch: {
    selected () {
      this.select()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Selectable.vue?82457700